<template>
	<div class="content-container">
		<!-- 版权描述 -->
		<span class="copyright">Copyright © 华仁大健康管理咨询有限公司</span>
		<!-- 版权描述 end -->

		<!-- logo -->
		<img class="logo" src="http://oss.huarendjk.com/files/iYNJzaW2seymnMzdrjyndhjtG9zP6LC97hBsBXLG.png" alt="logo">
		<!-- logo end -->

		<div class="login-box">
			<span class="welcome-speech">欢迎使用华仁康家后台</span>
			<section class="login-type">
				<div @click="switchTab(0)" :class="{'avtive-tab': tabIndex == 0}">康家</div>
				<div @click="switchTab(1)" :class="{'avtive-tab': tabIndex == 1}">代理</div>
			</section>
			<div class="form-container">
				<el-form :model="form" ref="form" :rules="rules" @submit.native.prevent>
					<el-form-item prop="username">
						<input class="input-item" v-model="form.username" placeholder="请输入账号" />
					</el-form-item>
					<el-form-item prop="password">
						<input class="input-item" type="password" v-model="form.password" placeholder="请输入密码" />
					</el-form-item>
					<!-- 					<section class="helper">
						<div>
							<el-checkbox-group v-model="mark">
								<el-checkbox label="记住密码" @change="handleCheckboxChange" :checked="isChecked" name="type"></el-checkbox>
							</el-checkbox-group>
						</div>
						<span>忘记密码?</span>
					</section> -->
					<el-form-item>
						<el-button class="submit-btn" type="primary" native-type="submit" @click="onSubmit">登录
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 默认 tab
				tabIndex: 0,
				// 记住密码
				mark: '',
				// 选中记住密码
				isChecked: false,
				bgs: [{
					id: 1,
					pic: require("@/assets/bg.jpg"),
					tips: '测试'
				}],
				form: {
					username: '',
					password: '',
					// type: 'merchant',
				},
				rules: {
					username: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			// 记住密码
			handleCheckboxChange(e) {
				let isTrue = e;
				this.isChecked = isTrue;
			},
			// tab 切换
			switchTab(index) {
				this.tabIndex = index;
				// 康家后台
				if (index == 0) {
          return
				} else {
					// 代理后台
					this.$router.push('/agent/login')
					window.sessionStorage.removeItem('token');
				}
			},
			onSubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.$util.post('merchant/login', this.form).then(res => {
							if (res.code > 0) {
								this.$message(res.msg)
							} else {
								console.log('login res', res)
								window.sessionStorage.setItem('token', res.data.token)
								window.sessionStorage.setItem('code', res.data.code)
								window.sessionStorage.setItem('userId', res.data.id)
								window.sessionStorage.setItem('title', res.data.title)
								window.sessionStorage.setItem('username', res.data.username)
								this.$router.push('/')
							}
							console.log(this.$util)
						})
					} else {
						alert('账号密码错误')
						return false;
					}
				});
			},
			toAgent() {
				this.$router.push('/agent/login')
				window.sessionStorage.removeItem('token')
			}
		},
	}
</script>


<style scoped lang="less">
	.content-container {
		position: relative;
		height: 100vh;
		background-image: url('http://oss.huarendjk.com/files/s7twUnbq69D20EFdfPLzZdOjHtEWywjGBGCrbu6I.png');
		background-size: 100% 100vh;
		overflow-y: scroll;

		.copyright {
			position: absolute;
			left: 40px;
			bottom: 40px;
			font-size: 16px;
			font-weight: 400;
			color: #FFFFFF;
		}

		.logo {
			position: absolute;
			left: 40px;
			top: 40px;
			width: 186.02px;
			height: 52.06px;
		}
	}

	.avtive-tab {
		border-bottom: 5px solid #007CFF;
		color: #007CFF;
	}

	.bg .el-image {
		width: 100%;
		height: 100%;
	}

	.login-box {
		position: absolute;
		top: 15%;
		right: 300px;
		width: 430px;
		height: 557px;
		background: rgba(255, 255, 255);
		box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.3);
		border-radius: 4px;
		padding: 41px;

		.welcome-speech {
			font-size: 30px;
			font-weight: 400;
			color: #333333;
		}

		.form-container {
			margin-top: 39px;

			input:focus {
				outline: 2px solid #409EFF;
			}

			.helper {
				display: flex;
				width: 100%;
				align-items: center;
				justify-content: space-between;
				color: #007CFF;

				span:hover {
					cursor: pointer;
				}
			}

			.submit-btn {
				margin-top: 70px;
				width: 100%;
				height: 68px;
				font-size: 20px;
				font-weight: bold;
				color: #FFFFFF;
			}

			.input-item {
				width: 100%;
				height: 68px;
				background: rgba(246, 246, 246, 0.39);
				border: 1px solid #DDDDDD;
				border-radius: 4px;
				font-size: 20px;
				padding: 0 5px;
			}

			.input-item::placeholder {
				position: relative;
				left: 30px;
				font-size: 20px;
				font-weight: 500;
				color: #888888;
			}
		}

		.login-type {
			margin-top: 59px;
			display: flex;
			justify-content: space-between;
			text-align: center;
			font-size: 24px;
			font-weight: 500;
			color: #DDDDDD;

			div:hover {
				cursor: pointer;
			}

			div {
				padding-bottom: 8px;
				width: 136px;
			}
		}
	}

	.other {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #409EFF;
	}
</style>